import React from "react";
import { Link } from "gatsby";
var PageSectionContainer = function PageSectionContainer(_ref) {
    var to = _ref.to, className = _ref.className, children = _ref.children, _ref$row = _ref.row, row = _ref$row === void 0 ? false : _ref$row, backgroundImage = _ref.backgroundImage, backgroundColor = _ref.backgroundColor;
    var computedClasses = "flex w-full border-t-8 border-solid border-makroOrange\n   " + (className || "") + " " + (row ? "flex-row" : "flex-col");
    var computedStyle = backgroundImage ? {
        backgroundImage: "url(" + backgroundImage + ")",
        backgroundSize: "cover",
        backgroundColor: backgroundColor
    } : {
        backgroundColor: backgroundColor
    };
    if (to !== undefined) {
        return /*#__PURE__*/ React.createElement(Link, {
            to: to,
            className: computedClasses,
            style: computedStyle
        }, children);
    }
    else {
        return /*#__PURE__*/ React.createElement("div", {
            className: computedClasses,
            style: computedStyle
        }, children);
    }
};
export default PageSectionContainer;
